// Shared constants for the Operations Timesheets screen.

export const EMPLOYMENT_TYPE_COLORS = {
  Employee: 'blue',
  Casual: 'orange',
  Contractor: 'purple',
  Seasonal: '#067647',
};

export const TIMESHEET_STATUS = {
  pending: { label: 'Pending', color: 'orange' },
  approved: { label: 'Approved', color: '#067647' },
};

export const TIMESHEET_FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'pending', label: 'Pending Review' },
  { key: 'approved', label: 'Approved' },
  { key: 'conflicts', label: 'Conflicts' },
];
